import {ReactNode} from 'react';
import {LoadingState} from '../ds/StateView.tsx';

interface SpinnerIfLoadingProps {
    children?: ReactNode;
    loading: boolean;
    message?: string;
    // The shape of what's loading, so the skeleton matches it.
    variant?: 'cards' | 'rows' | 'block';
}

// Shows the loading skeleton (after a short delay) instead of its children.
const SpinnerIfLoading: React.FC<SpinnerIfLoadingProps> = ({
    children,
    loading,
    message,
    variant = 'block'
}) => {
    if (loading) {
        return <LoadingState variant={variant} message={message} />;
    }

    return <>{children}</>;
};

export default SpinnerIfLoading;
